<script lang="ts" setup>
import type { DialogOverlayProps } from '@fondof-ui/components/drawer/types'
import { DrawerOverlay } from 'vaul-vue'

const props = defineProps<DialogOverlayProps>()
</script>

<template>
  <DrawerOverlay v-bind="props" />
</template>
